/* eslint-disable @typescript-eslint/no-explicit-any */
import { useContext } from "react";
import { notification } from "antd";
import authAtom from "../atoms/auth.atom";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { AxiosContext } from "../contexts/AxiosContext";
import { getRequest, handleMessage, postRequest, putRequest } from "../contexts/AxiosRequests";
import { useRecoilState } from "recoil";


export function useGetUnitDetails(successAction?: any, errorAction?: any) {
  const url = "/userBuildingDetails"
  const axios = useContext(AxiosContext)
  const [auth, setAuth] = useRecoilState(authAtom)

  return useQuery(
    ["key:get_unit_details"],
    () => getRequest(axios as any, url),
    {
      onError: (err: any) => {errorAction?.(err); notification.error({message: handleMessage(err)})},
      onSuccess: (res: any) => {successAction?.(res); setAuth({...auth, unit: {...auth?.unit, ...(res?.data || {})}})},
    }
  )
} 

export function useGetProfile(successAction?: any, errorAction?: any) {
  const url = "/singleProfile"
  const axios = useContext(AxiosContext)
  const [auth, setAuth] = useRecoilState(authAtom)

  return useQuery(
    ["key:get_user_profile"],
    () => getRequest(axios as any, url),
    {
      onError: (err: any) => {errorAction?.(err); notification.error({message: handleMessage(err)})},
      onSuccess: (res: any) => {successAction?.(res); setAuth({...auth, user: {...auth?.user, ...(res?.data || {})}})},
    }
  )
} 

export function useSetProfile(successAction?: any, errorAction?: any) {
  const url = "/updateProfile"
  const query = useQueryClient()
  const axios = useContext(AxiosContext)

  return useMutation(
    (payload: any) => putRequest(axios as any, url, payload),
    {
      onError: (err: any) => {errorAction?.(err); notification.error({message: handleMessage(err)})},
      onSuccess: (res: any) => {successAction?.(res);
        query.invalidateQueries("key:get_user_profile");
        notification.success({message: res?.message || "action successful"})
      },
    }
  )
} 

export function useSetPassword(successAction?: any, errorAction?: any) {
  const url = "/changePassword"
  const query = useQueryClient()
  const axios = useContext(AxiosContext)

  return useMutation(
    (payload: any) => postRequest(axios as any, url, payload),
    {
      onError: (err: any) => {errorAction?.(err); notification.error({message: handleMessage(err)})},
      onSuccess: (res: any) => {successAction?.(res);
        query.invalidateQueries("key:get_user_profile");
        notification.success({message: res?.message || "action successful"})
      },
    }
  )
} 